"use strict";

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _path = require("path");

var _path2 = _interopRequireDefault(_path);

var root = _path2["default"].resolve(__dirname, "../../../");

exports["default"] = function (module) {
  if (module.parent && module.parent.filename.indexOf(root) !== 0) {
    throw new Error("Don't hotlink internal Babel files.");
  }
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/lib/babel/tools/protect.js
 ** module id = 150
 ** module chunks = 0
 **/